import { authenticatedApi } from "../api";
import { MICROSERVICE_CONFIG } from "../../config/configs";

export const get_all_cuisine_api = async (params) => {
	return new Promise((resolve, reject) => {
		authenticatedApi
			.get(`${MICROSERVICE_CONFIG.RESTAURANT}/cuisines?${params}`)
			.then((response) => {
				let { data } = response;
				resolve(data);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const delete_cuisine_by_id_api = async (id) => {
	return new Promise((resolve, reject) => {
		authenticatedApi
			.delete(`${MICROSERVICE_CONFIG.RESTAURANT}/cuisines/${id}`)
			.then((response) => {
				let { data } = response;
				resolve(data);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const add_cuisine = async (payload) => {
	return new Promise((resolve, reject) => {
		authenticatedApi
			.post(`${MICROSERVICE_CONFIG.RESTAURANT}/cuisines`, payload)
			.then((response) => {
				let { data } = response;
				resolve(data);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const update_cuisine = async (body) => {
	return new Promise((resolve, reject) => {
		authenticatedApi
			.patch(`${MICROSERVICE_CONFIG.RESTAURANT}/cuisines/${body.id}`, body.body)
			.then((response) => {
				let { data } = response;
				resolve(data);
			})
			.catch((error) => {
				reject(error);
			});
	});
};
